import { useTranslation } from "react-i18next";
import AppInput from "../forms/AppInput";
import { useForm } from "react-hook-form";
import { useContext, useEffect, useMemo, useState } from "react";
import { sortedCountriesByLanguage } from "../../helpers/options/countries";
import i18next from "i18next";
import AppUploadButton from "../forms/AppUploadButton";
import {
  classNames,
  onDirectUpload,
  showApiErrorMessages,
} from "../../helpers";
import StudentModel from "../../api/models/StudentModel";
import LiaisonModel from "../../api/models/LiaisonModel";
import TutorModel from "../../api/models/TutorModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import { ToastContext } from "../../App";
import { ApiResponse } from "../../api/apiResponse";
import InputErrors from "../forms/InputErrors";
import PhoneNumberInput from "../forms/phone-input/PhoneNumberInput";
import moment from "moment-timezone";
import AppDatePicker from "../forms/AppDatePicker";
import { getTimezone, toApiDate } from "../../helpers/date_helpers";
import DropDown, { DropDownOption } from "../forms/dropdown/DropDown";
import LogoWithLanguage from "../logo-with-language/LogoWithLanguage";
import { useTelawah } from "../../hooks/useTelawah";
import CandidateModel from "../../api/models/CandidateModel";
import TelawahModel from "../../api/models/TelawahModel";
import EditorModal from "../modal/EditorModal";
import TermsAndConditionModal from "../modal/TermsAndConditionModal";
import SupervisorModel from "../../api/models/SupervisorModel";
type UserPersonalInfoProps = {
  user:
    | StudentModel
    | LiaisonModel
    | TutorModel
    | CandidateModel
    | SupervisorModel;
  updateUser: (data: any) => Promise<ApiResponse>;
  afterSubmit?: (key?: string) => void;
  prevPage?: () => void;
  submitButtonText?: string;
  previousButtonText?: string;
  stepInfo?: string;
  stylesClass?: string;
  isEditable?: boolean;
  candidateStatus?: boolean;
  showTitle?: boolean;
  isEmailEditable?: boolean | null;
};
const NAME_REGEX_PATTERN = /^(([a-zA-Zء-ي])+\s*)+$/;

export default function UserPersonalInfo(props: UserPersonalInfoProps) {
  const {
    user,
    updateUser,
    afterSubmit,
    submitButtonText,
    previousButtonText,
    stepInfo,
    prevPage,
    stylesClass,
    isEditable,
    candidateStatus,
    showTitle = true,
    isEmailEditable = null,
  } = props;
  const toast = useContext(ToastContext);
  const LocalBasePath = "page.accountInfo";
  const { telawahOptions } = useTelawah();
  const defaultBirthdayValue = !!user?.birth_date
    ? moment(user.birth_date).toDate()
    : undefined;
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [open, setOpen] = useState<boolean>(false);
  var [signedId, setSignedId] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [birthdayDate, setBirthdayDate] =
    useState<Date | undefined>(defaultBirthdayValue);
  const [isBirthdayDateError, setIsBirthdayDateError] = useState(false);
  const [profilePictureURL, setProfilePictureURL] = useState(
    user?.profile_picture_url
  );
  const [openTermsModal, setOpenTermsModal] = useState<boolean>(false);
  const [newCandidateData, setNewCandidateData] = useState({});
  const [imageFileURL, setImageFileURL] = useState<File | null>(null);

  const initialValues: any = {
    firstname: user?.firstName || "",
    middlename: user?.middleName,
    lastname: user?.lastName,
    mobile: user?.phoneNumber,
    country: user?.country,
    sex: user?.gender || "",
    birthday: user?.birth_date,
    motherlang: user?.native_language,
    email: !!user?.email ? user?.email : user?.account?.email,
    accountId: user?.account?.id,
    createdAt: user?.created_at?.format("DD/MM/YYYY hh:mm A"),
    telawahId: user?.telawah_id,
    academicLevel: user?.academic_level,
    educationLanguage: user?.content_language,
  };

  const onSetProfile = async (val: any) => {
    try {
      const reso = await val;
      if (!!reso) {
        setSignedId(reso);
        setTimeout(() => {
          setIsUploading(false);
        }, 1000);
      }
    } catch (error) {
      setIsUploading(false);
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({ defaultValues: initialValues });

  const saveData = async (data: any, signedId: any) => {
    let apiData: any = {
      full_name: `${data.firstname?.trim()} ${data.middlename?.trim()} ${data.lastname?.trim()}`,
      first_name: data.firstname?.trim(),
      middle_name: data.middlename?.trim(),
      last_name: data.lastname?.trim(),
      phone_number: data.mobile,
      native_language: data.motherlang,
      country: data.country,
      gender: data.sex,
      academic_level: data.academicLevel,
      birth_date: toApiDate(birthdayDate!),
      account_attributes: {
        id: data?.accountId,
        timezone: getTimezone(),
      },
    };

    if (!!signedId) {
      apiData["profile_picture"] = signedId;
    } else if (!signedId && !!user?.profile_picture_url) {
      apiData["profile_picture_url"] = user.profile_picture_url;
    }
    if (candidateStatus) {
      apiData = {
        ...apiData,
        telawah_id: data.telawahId,
        content_language: data.educationLanguage,
      };
    }
    if (
      isEmailEditable != null
        ? !isEmailEditable
        : !isEditable && candidateStatus
    )
      apiData["email"] = data.email;

    const response: ApiResponse = await updateUser(apiData);
    if (response.isSuccess) {
      toast?.success("savedSuccessfully");
      afterSubmit!(data.email);
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast?.error(errorMessage);
      });
    }
  };

  const onSubmit = (data: any) => {
    let dataIsValid = Object.keys(errors).length === 0;
    const isBirthDateValid = validateDate();
    dataIsValid = dataIsValid && isBirthDateValid;
    if (!isEditable && candidateStatus && dataIsValid && !openTermsModal) {
      setNewCandidateData(data);
      setOpenTermsModal(true);
    } else if (dataIsValid) {
      saveData(data, signedId);
    }
  };
  const termsAndConditionAgreement = (agree: boolean) => {
    if (agree) {
      saveData(newCandidateData, signedId);
    } else {
      setOpenTermsModal(false);
    }
  };
  const onUpload = async (file: File, saveStatus?: boolean) => {
    if (!file) return;
    setIsUploading(true);
    setImageFileURL(file);
    let previewUrl: string | null = null;
    try {
      previewUrl = URL.createObjectURL(file);
    } catch (error) {
      console.log(error);
    }
    if (!!previewUrl && !saveStatus) {
      setProfilePictureURL(previewUrl);
      setOpen(true);
      setIsUploading(false);
    } else if (!!saveStatus && !!previewUrl) {
      setProfilePictureURL(previewUrl);
      onDirectUpload(file, onSetProfile);
      setOpen(false);
    }
  };

  const handelDateChange = (date: Date | null) => {
    setBirthdayDate(date || undefined);
    setIsBirthdayDateError(false);
  };
  const closeModalCropImage = () => {
    setProfilePictureURL(user?.profile_picture_url ?? "");
    setOpen(false);
  };

  const validateDate = (): boolean => {
    const isBirthDateValid = !!birthdayDate;
    setIsBirthdayDateError(!isBirthDateValid);
    return isBirthDateValid;
  };

  const countriesOptions = useMemo(() => {
    return sortedCountriesByLanguage(i18next.language).map((country) => {
      return {
        key:
          i18next.language === "ar"
            ? country.country_name_ar
            : country.country_name,
        value: country.country_name,
      };
    });
  }, [i18next.language]);

  const academicLevelOptions = [
    { key: t("uneducated"), value: "uneducated" },
    { key: t("highSchool"), value: "high school" },
    { key: t("diplom"), value: "diplom" },
    { key: t("bachelor"), value: "bachelor" },
    { key: t("master"), value: "master's" },
    { key: t("phd"), value: "phd" },
  ];

  const languageOptions = [
    { key: t("arabic"), value: "arabic" },
    { key: t("english"), value: "english" },
  ];

  const contentLanguageOptions = [{ key: t("arabic"), value: "arabic" }];

  return (
    <div
      className={classNames(
        "w-full   flex flex-col ",
        (candidateStatus && isEditable) || !showTitle
          ? ""
          : "divide-y  divide-gray-200",
        stylesClass
      )}
    >
      <div>
        <div className="flex flex-col items-center justify-between w-full md:flex-row">
          {!isEditable && <LogoWithLanguage />}
        </div>
        {!!showTitle && (
          <div
            className={classNames(
              "pb-6 px-4 md:px-0",
              isEditable ? "pb-6 pt-6 md:pt-0" : "pb-2 mt-6"
            )}
          >
            {!candidateStatus ? (
              <h1
                className={classNames(
                  " text-gray-900 ",
                  isEditable
                    ? "text-lg leading-6 font-medium"
                    : "text-3xl font-bold mb-2"
                )}
              >
                {isEditable ? t("accountDetails") : t("createAccount")}
              </h1>
            ) : (
              <h1
                className={classNames(
                  " text-gray-900 ",
                  isEditable
                    ? "text-lg leading-6 font-medium"
                    : "text-3xl font-bold mb-2"
                )}
              >
                {isEditable ? t("personalInfo") : t("createAccount")}
              </h1>
            )}
            <p
              className={classNames(
                "text-gray-500",
                isEditable ? " text-sm" : "text-lg leading-6"
              )}
            >
              {!isEditable ? t("fillInputs") : ""}
            </p>
          </div>
        )}
      </div>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="pb-6 space-y-8 divide-y divide-gray-200"
      >
        <div
          className={classNames(
            "px-4 md:px-0",
            candidateStatus && isEditable ? "pt-0" : "pt-6"
          )}
        >
          {!isEditable && (
            <>
              <h3 className="pb-2 text-lg font-medium leading-6 text-gray-800">
                {t("publicInfo")}
              </h3>
            </>
          )}
          <div className="pt-0">
            <label
              htmlFor="photo"
              className="block pb-1 text-sm font-medium text-gray-700"
            >
              {t("file")}
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2">
              <div className="flex items-center">
                <UserProfilePictureAvatar
                  profilePictureUrl={profilePictureURL}
                  loading={isUploading}
                />
                <AppUploadButton
                  acceptFiles="image/*"
                  isUploading={setIsUploading}
                  title={t("upload")}
                  onUpload={onUpload}
                />
              </div>
            </div>
            <label className={"mt-6 block text-sm font-medium text-gray-700"}>
              {t("name")} *
            </label>
            <div className="flex flex-col gap-y-5 gap-x-4 sm:flex-row">
              <div className="w-full max-w-lg sm:max-w-xs">
                <div className="mt-1">
                  <AppInput
                    hideLabel={true}
                    label={t("first")}
                    register={register}
                    error={errors.firstname}
                    scehema={{
                      required: true,
                      pattern: {
                        value: NAME_REGEX_PATTERN,
                        message: t("enterCharactersOnly"),
                      },
                    }}
                    placeholder={t("first")}
                    type="text"
                    name="firstname"
                    id="firstname"
                    autoComplete="given-name"
                    className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-brandblue-500 focus:border-brandblue-500 sm:text-sm"
                  />
                </div>
              </div>

              <div className="w-full max-w-lg sm:max-w-xs">
                <div className="mt-1">
                  <AppInput
                    hideLabel={true}
                    label={t("father")}
                    register={register}
                    error={errors.middlename}
                    scehema={{
                      required: true,
                      pattern: {
                        value: NAME_REGEX_PATTERN,
                        message: t("enterCharactersOnly"),
                      },
                    }}
                    placeholder={t("father")}
                    type="text"
                    name="middlename"
                    id="middlename"
                    autoComplete="middle-name"
                    className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-brandblue-500 focus:border-brandblue-500 sm:text-sm"
                  />
                </div>
              </div>
              <div className="w-full max-w-lg sm:max-w-xs">
                <div className="mt-1">
                  <AppInput
                    hideLabel={true}
                    label={t("family")}
                    register={register}
                    error={errors.lastname}
                    scehema={{
                      required: true,
                      pattern: {
                        value: NAME_REGEX_PATTERN,
                        message: t("enterCharactersOnly"),
                      },
                    }}
                    placeholder={t("family")}
                    type="text"
                    name="lastname"
                    id="lastname"
                    autoComplete="family-name"
                    className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-brandblue-500 focus:border-brandblue-500 sm:text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          {!isEditable && (
            <div className="sm:col-span-2">
              <div className="max-w-lg mt-4 sm:max-w-xs">
                <label
                  htmlFor="sex"
                  className="block mb-1 text-sm font-medium text-gray-700 sm:mt-px "
                >
                  {t("sex")} *
                </label>
                <div className="flex gap-8">
                  <div className="flex items-center">
                    <input
                      {...register("sex", { required: true })}
                      id="sex"
                      name="sex"
                      type="radio"
                      value={"male"}
                      className="w-4 h-4 border-gray-300 focus:ring-brandblue-500 text-brandblue-600"
                    />
                    <label
                      htmlFor="sex"
                      className="block text-sm font-medium text-gray-700 ltr:ml-3 rtl:mr-3"
                    >
                      {t("male")}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      {...register("sex", { required: true })}
                      id="sex"
                      name="sex"
                      type="radio"
                      value={"female"}
                      className="w-4 h-4 border-gray-300 focus:ring-brandblue-500 text-brandblue-600"
                    />
                    <label
                      htmlFor="sex"
                      className="block text-sm font-medium text-gray-700 ltr:ml-3 rtl:mr-3"
                    >
                      {t("female")}
                    </label>
                  </div>
                </div>
                {InputErrors(
                  errors.sex,
                  { required: true },
                  t("sex"),
                  t("sex")
                )}
              </div>
            </div>
          )}

          <div className="sm:col-span-2">
            <div className="max-w-lg mt-6 sm:max-w-xs">
              <AppDatePicker
                // We are manually adding the * to the label here instead of using the required prop is
                // because the required prop will start showing the default HTML pop over and we do not want that.
                label={`${t("birthday")} *`}
                placeholder={t("birhdatyPlaceHolder")}
                selected={birthdayDate}
                onChange={handelDateChange}
                error={
                  isBirthdayDateError
                    ? i18next.t(`errors.input.required`, {
                        name: t("birthday"),
                      })
                    : null
                }
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <div className="max-w-lg mt-6 sm:max-w-xs">
              <DropDown
                id="motherlang"
                name="motherlang"
                schema={{ required: true }}
                register={register}
                setValue={(value: any) =>
                  setValue("motherlang", value, { shouldValidate: true })
                }
                defaultValue={getValues("motherlang")}
                label={t("motherTongue")}
                placeholder={t("motherTongue")}
                error={!!errors.motherlang}
                options={languageOptions}
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <div className="max-w-lg mt-6 sm:max-w-xs">
              <DropDown
                id="academicLevel"
                name="academicLevel"
                schema={{ required: true }}
                register={register}
                setValue={(value: any) =>
                  setValue("academicLevel", value, { shouldValidate: true })
                }
                defaultValue={getValues("academicLevel")}
                label={t("academicLevel")}
                placeholder={t("academicLevel")}
                error={!!errors.academicLevel}
                options={academicLevelOptions}
              />
            </div>
          </div>
        </div>

        <div className="px-4 md:px-0">
          <h3 className="pt-8 text-lg font-medium leading-6 text-gray-900">
            {t("contactInfo")}
          </h3>
          <div className="mt-6">
            <div className="sm:col-span-2">
              <div className="max-w-lg sm:max-w-xs">
                <DropDown
                  id="country"
                  name="country"
                  schema={{ required: true }}
                  register={register}
                  setValue={(value: any) =>
                    setValue("country", value, { shouldValidate: true })
                  }
                  defaultValue={`${getValues("country")}`}
                  label={t("country")}
                  placeholder={t("countryPlaceHolder")}
                  error={!!errors.country}
                  options={countriesOptions}
                />
              </div>
            </div>
          </div>

          <div className="sm:col-span-2">
            <div className="max-w-lg mt-6 sm:max-w-xs">
              <AppInput
                defaultValue={!!user ? user.account?.email : ""}
                label={t("email")}
                register={register}
                error={errors.email}
                scehema={{
                  required: true,
                }}
                disabled={
                  isEmailEditable != null
                    ? isEmailEditable
                    : !isEditable && candidateStatus
                    ? false
                    : true
                }
                placeholder={t("email")}
                type="email"
                autoComplete="email"
                name="email"
                id="email"
                className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-brandblue-500 focus:border-brandblue-500 sm:text-sm"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <div className="max-w-lg mt-6 sm:max-w-xs">
              <PhoneNumberInput
                control={control}
                label={t("mobile")}
                name={"mobile"}
                placeholder={"+1 234 567 8910"}
                schema={{ required: true }}
              />
            </div>
          </div>
        </div>
        {candidateStatus && (
          <div className="px-4 md:px-0">
            <h3 className="pt-8 text-lg font-medium leading-6 text-gray-900">
              {t("readingInfo")}
            </h3>
            <div className="sm:col-span-2">
              <div className="max-w-lg mt-6 sm:max-w-xs">
                <DropDown
                  id="telawahId"
                  name="telawahId"
                  schema={{ required: true }}
                  register={register}
                  setValue={(value: any) =>
                    setValue("telawahId", value, { shouldValidate: true })
                  }
                  disabled={!isEditable && candidateStatus ? false : true}
                  defaultValue={`${getValues("telawahId")}`}
                  label={t("novel")}
                  subLabel={t("allNovels")}
                  placeholder={t("novel")}
                  error={!!errors.telawahId}
                  options={telawahOptions || []}
                />
              </div>
            </div>

            <div className="sm:col-span-2">
              <div className="max-w-lg mt-6 sm:max-w-xs">
                <DropDown
                  id="educationLanguage"
                  name="educationLanguage"
                  schema={{ required: true }}
                  disabled={!isEditable && candidateStatus ? false : true}
                  register={register}
                  setValue={(value: any) =>
                    setValue("educationLanguage", value, {
                      shouldValidate: true,
                    })
                  }
                  defaultValue={getValues("educationLanguage")}
                  label={t("educationLanguage")}
                  placeholder={t("educationLanguage")}
                  error={!!errors.educationLanguage}
                  options={contentLanguageOptions}
                  subLabel={t("allLanguages")}
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <div>
                {isEditable && (
                  <p className="w-full mt-6 font-sans text-sm text-gray-500 ">
                    {t("createdAt", { date: initialValues.createdAt })}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
        <div
          className={classNames(
            "z-20 px-4 py-4 justify-end md:px-0 w-full sticky items-end  bottom-0 bg-white gap-3 flex "
          )}
        >
          {" "}
          {!!previousButtonText && (
            <div>
              <button
                disabled={isUploading}
                type="button"
                data-cy="prev"
                onClick={() => prevPage!()}
                className="flex justify-center flex-shrink-0 px-6 py-2 text-sm font-medium bg-transparent border rounded-md shadow-sm md:px-4 border-gray text-gray focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 disabled:bg-gray-400"
              >
                {previousButtonText}
              </button>
            </div>
          )}
          <div className="flex flex-col items-center gap-4 md:flex-row">
            <div className="flex justify-center flex-shrink-0 text-sm font-medium text-gray-700 md:justify-end">
              {stepInfo}
            </div>
            <button
              disabled={isUploading}
              type="submit"
              data-cy="next"
              className="flex justify-center flex-shrink-0 px-6 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm md:px-4 bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 disabled:bg-gray-400"
            >
              {submitButtonText ? submitButtonText : t("save")}
            </button>
          </div>
        </div>
      </form>
      <TermsAndConditionModal
        isOpen={openTermsModal}
        onClose={(val) => termsAndConditionAgreement(val)}
      />
      <EditorModal
        image={imageFileURL}
        isOpen={open}
        onClose={closeModalCropImage}
        onUpload={onUpload}
        isUploading={setIsUploading}
      />
    </div>
  );
}
